import Shop from '../shop';

export default class CarManufacturer extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Car manufacturer',
            id:                   'CarManufacturer',
            coolDown:             6000,
            faClass:              'fa-car',
            individualCostFactor: 1.105,
            baseEarnings:         12899000000.0,
            baseCosts:            309586821120.0,
            grade:                11
        });
    }
}
